module.exports = __webpack_public_path__ + "static/img/01.b19004e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/01.jpg
// module id = Mj1u
// module chunks = 1